$("form").submit(function () {
    $(this).find("input[type='submit']").val("bezig met registreren...");
    $(this).find("input[type='submit']").attr("disabled", "disabled");
});


// WEBPACK FOOTER //
// ./js/registerreseller.js